

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";
// decrementQuantity
// DECREMENTQUANTITY
const DECREMENTQUANTITY= createAsyncThunk(
  "decrementQuantity/decrementQuantity",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const decrementQuantitySlice = createSlice({
  name: "decrementQuantitySlice",
  initialState: {
    decrementQuantity: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfdecrementQuantity: (state) => {
        state.decrementQuantity.loading = false
        state.decrementQuantity.error = false
        state.decrementQuantity.data = []
        state.decrementQuantity.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(DECREMENTQUANTITY.fulfilled, (state, action) => {
      state.decrementQuantity = {
        ...state.decrementQuantity,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(DECREMENTQUANTITY.pending, (state, action) => {
      state.decrementQuantity = {
        ...state.decrementQuantity,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(DECREMENTQUANTITY.rejected, (state, action) => {
      state.decrementQuantity = {
        ...state.decrementQuantity,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const decrementQuantityAction = {
    DECREMENTQUANTITY,
};

export { decrementQuantityAction };
export default decrementQuantitySlice.reducer;
export const {setInitialStateOfdecrementQuantity} = decrementQuantitySlice.actions
